import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import EvaluationUnitForm from './EvaluationUnitForm';

const EvaluationUnitActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const EvaluationUnitEdit = (props: any) => {
  return (
    <Edit actions={<EvaluationUnitActions {...props} />} {...props}>
      <EvaluationUnitForm />
    </Edit>
  );
};

export default EvaluationUnitEdit;
